<section class="main-section">
  <!-- Header -->
  <div class="modal-header d-flex justify-content-between align-items-center">
    <div class="heading">
      <div class="title">{{ data?.create ? 'Add New Coupon' : 'Update Coupon' }}</div>
      <div class="subtitle">Configure your coupon details and generation settings</div>
    </div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="body-part">
    <div class="form-card">
      <div class="form-group">
        <label>Coupon Category <span class="required">*</span></label>
        <div class="radio-group mt-2">
          <div class="radio-option">
            <input type="radio" id="statusActive" value="CAMPAIGN" [(ngModel)]="couponPurpose">
            <label for="statusActive">Campaign Coupon</label>
          </div>
          <div class="radio-option">
            <input type="radio" id="statusInactive" value="REFERRAL_PROGRAM" [(ngModel)]="couponPurpose">
            <label for="statusInactive">Referral Coupon</label>
          </div>
        </div>
      </div>
      <div class="br m-3"></div>
      <div class="grid-section">
        <div class="form-group">
          <label>Coupon Name <span class="required">*</span></label>
          <input type="text" [(ngModel)]="createPayload.couponName"
            (blur)="createPayload.couponName = createPayload.couponName?.trim()" class="form-control"
            placeholder="e.g. Summer Sale 2024">
        </div>

        <div class="form-group" *ngIf="this.couponPurpose === 'REFERRAL_PROGRAM'">
          <label>Coupon Type <span class="required">*</span></label>
          <select class="form-select" [(ngModel)]="createPayload.couponValueType">
            <option value="" disabled selected>Select coupon type</option>
            <option value="PERCENTAGE">Percentage</option>
            <option value="FIXED">Fixed Amount</option>
          </select>
        </div>

        <div class="form-group" *ngIf="this.couponPurpose === 'REFERRAL_PROGRAM'">
          <label>Coupon Value <span class="required">*</span></label>
          <input type="text" [(ngModel)]="createPayload.couponValue" class="form-control"
            placeholder="Enter coupon value">
        </div>

        <div class="form-group"
          *ngIf="createPayload.couponValueType === 'PERCENTAGE' && this.couponPurpose === 'REFERRAL_PROGRAM'">
          <label>Maximum discount amount <span class="required">*</span></label>
          <input type="number" [(ngModel)]="createPayload.maxRedeemableAmount" class="form-control"
            placeholder="e.g. 500">
        </div>

        <div class="form-group" *ngIf="this.couponPurpose === 'REFERRAL_PROGRAM'">
          <label>Minumum order value <span class="required">*</span></label>
          <input type="number" [(ngModel)]="createPayload.minOrderValue" class="form-control" placeholder="e.g. 1000">
        </div>

        <div class="form-group">
          <label>Description 1</label>
          <input type="text" [(ngModel)]="createPayload.descLine1" class="form-control"
            placeholder="Enter primary description (optional)">
        </div>

        <div class="form-group">
          <label>Description 2</label>
          <input type="text" [(ngModel)]="createPayload.descLine2" class="form-control"
            placeholder="Enter secondary description (optional)">
        </div>

        <div class="form-group">
          <label>Status</label>
          <div class="radio-group mt-2">
            <div class="radio-option">
              <input type="radio" id="statusActive" value="true" [(ngModel)]="status">
              <label for="statusActive">Active</label>
            </div>
            <div class="radio-option">
              <input type="radio" id="statusInactive" value="false" [(ngModel)]="status">
              <label for="statusInactive">Inactive</label>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Event Date</label>
          <input type="date" [(ngModel)]="createPayload.effectiveDate" [min]="today"
            (ngModelChange)="onStartDateChange($event)" class="form-control">
        </div>

        <div class="form-group">
          <label>Valid Till</label>
          <input type="date" [(ngModel)]="createPayload.expiryDate" [min]="createPayload.effectiveDate"
            class="form-control">
        </div>

      </div>

      <div class="form-group mt-2 mb-0">
        <label>Terms & Conditions</label>
        <textarea [(ngModel)]="createPayload.termsAndConditions" placeholder="Enter terms and conditions (optional)"
          class="form-control" rows="3"></textarea>
      </div>
    </div>

    <div class="coupon-type-section">
      <!-- AUTO GENERATED SECTION -->
      <div class="grid-section" *ngIf="generationMethod === 'AUTO_GENERATED'">
        <div class="form-group">
          <label>Coupon Count <span class="required">*</span></label>
          <input type="number" (click)="createPayload.couponsQuantity = ''" [(ngModel)]="createPayload.couponsQuantity"
            (ngModelChange)="updateMinDigitLength()" class="form-control" placeholder="Number of coupons to generate" />
        </div>

        <div class="form-group">
          <label>Coupon Prefix <span class="required">*</span></label>
          <input type="text" [(ngModel)]="createPayload.couponPrefix" (ngModelChange)="onPrefixChange($event)"
            (blur)="createPayload.couponPrefix = createPayload.couponPrefix?.trim()" class="form-control suffix"
            placeholder="e.g. SUMMER" />
        </div>

        <div class="form-group">
          <label>Coupon Suffix</label>
          <input type="text" [(ngModel)]="createPayload.couponSuffix" (ngModelChange)="updateMinDigitLength()"
            class="form-control suffix" placeholder="e.g. 24 (optional)" />
        </div>

        <div class="form-group">
          <label>Coupon Digit Length <span class="required">*</span></label>
          <input type="number" [(ngModel)]="createPayload.digitlength" (ngModelChange)="updateMinDigitLength()"
            (click)="createPayload.digitlength = ''" [min]="minDigitLength" [max]="maxDigitLength" class="form-control"
            placeholder="Length of random digits" />

          <div class="info-message" *ngIf="minDigitLength > 0">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            <span>Length must be between <strong>{{ minDigitLength }}</strong> and <strong>{{ maxDigitLength
                }}</strong></span>
          </div>
        </div>

        <div class="form-group mb-0">
          <label>Low Stock Alert</label>
          <input type="number" [(ngModel)]="createPayload.lowAlertCount" class="form-control"
            placeholder="Threshold for alert (optional)" />
        </div>

        <div class="form-group mb-0 d-flex flex-column justify-content-center">
          <label class="mb-2">Notify on low stock?</label>
          <div class="switch">
            <input type="checkbox" id="toggleSwitch" [(ngModel)]="createPayload.lowStockAlertNotification" />
            <span class="slider"></span>
          </div>
        </div>
      </div>

      <!-- CUSTOM UPLOAD SECTION -->
      <div class="upload-section d-flex flex-column align-items-center" (click)="fileInput.click()"
        *ngIf="generationMethod === 'CUSTOM_UPLOAD'">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5"
          stroke-linecap="round" stroke-linejoin="round" class="mb-3">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="17 8 12 3 7 8"></polyline>
          <line x1="12" y1="3" x2="12" y2="15"></line>
        </svg>
        <div class="upload-title">Upload Excel Data</div>
        <div class="upload-desc">
          The number of coupons in your excel will be added to this coupon batch.
        </div>
        <button class="btn add-btn" (click)="$event.stopPropagation(); fileInput.click()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="me-2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          Browse Files
        </button>
        <input type="file" name="myfile" hidden accept=".xls,.xlsx" class="pc-btn" #fileInput />
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <button class="btn cancel-btn" (click)="close()">Cancel</button>

    <!-- CREATE -->
    <button *ngIf="!btnLoader" class="btn add-btn"
      [disabled]="createPayload.couponPurpose === '' || !createPayload.couponName?.trim() || !createPayload.couponPrefix?.trim() || createPayload.couponsQuantity <= 0 || !createPayload.digitlength || minDigits"
      (click)="addCoupon()">
      {{ data?.create ? 'Create Coupon' : 'Update Coupon' }}
    </button>

    <!-- LOADING -->
    <button *ngIf="btnLoader" class="btn add-btn disabled" disabled>
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {{ data?.create ? 'Creating...' : 'Updating...' }}
    </button>
  </div>
</section>